import { useLocation } from "react-router-dom";
import { isLandingPath } from "./lpDom";

/** Sembunyikan elemen aplikasi (Mimi, prompt pasang, animasi) pada halaman landing page awam. */
export default function NotOnLanding({ children }) {
  const { pathname } = useLocation();
  return isLandingPath(pathname) || pathname.startsWith("/mimi/landing-builder") ? null : children;
}
